import gql from 'graphql-tag';

export const getAvailabilityQ = gql`
  query getAvailableRange($id: Int!) {
    ReservationAvailabilityRange(reservationId: $id) {
      blockedDates {
        id
        blockedDates
      }
      reservation {
        id
        checkIn
        checkOut
        reservationState
      }
      messages
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components_new/Inbox/chatQl.js